import { render, staticRenderFns } from "./Certificado.vue?vue&type=template&id=0a9fd33c&scoped=true"
import script from "./Certificado.vue?vue&type=script&lang=js"
export * from "./Certificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fd33c",
  null
  
)

export default component.exports